<template>
  <v-data-table :headers="headers" :items="items" :loading="loading" hide-actions>
    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
    <template slot="items" slot-scope="props">
      <tr>
        <grid-cell
          :header="header"
          :row="props.item"
          v-for="(header, index) in headers"
          :key="index"
        ></grid-cell>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import GridCell from '../../components/GridCell';
import { defaultDateTimeFormatter } from '../../utils';

export default {
  components: {
    GridCell,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      headers: [
        {
          text: this.$t('@backgroundErrorList/idColumnHeader'),
          align: 'left',
          sortable: false,
          value: 'id',
        },
        { text: this.$t('@backgroundErrorList/contextColumnHeader'), value: 'context' },
        { text: this.$t('@backgroundErrorList/messageColumnHeader'), value: 'message' },
        {
          text: this.$t('@backgroundErrorList/dateColumnHeader'),
          value: 'created',
          format: defaultDateTimeFormatter,
        },
      ],
    };
  },
};
</script>
